import Colors from "./Colors";
import theme from "./darkTheme";

export const styles = {
  // Base colors
  white: Colors.textPrimary,
  darkGreen: Colors.success,
  cardColor: Colors.bgSecondary,

  // Grey scale (updated for dark theme)
  grey: {
    0: Colors.bgElevated,
    50: Colors.bgTertiary,
    100: Colors.borderSecondary,
    200: Colors.borderPrimary,
    300: Colors.textMuted,
    400: Colors.textMuted,
    500: Colors.textSecondary,
    600: Colors.textSecondary,
    700: Colors.textSecondary,
    800: Colors.textPrimary,
    900: Colors.textPrimary,
  },

  cardStyle: {
    backgroundColor: Colors.bgSecondary,
    width: "100%",
    boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
    borderRadius: "8px",
    border: `1px solid ${Colors.borderSecondary}`,
    overflow: "hidden",
  },

  elevatedCard: {
    backgroundColor: Colors.bgTertiary,
    boxShadow: "0 4px 12px rgba(0,0,0,0.25)",
    borderRadius: "8px",
    border: `1px solid ${Colors.borderPrimary}`,
  },

  wizardCard: {
    position: "relative",
    backgroundColor: Colors.bgSecondary,
    width: "100%",
    boxShadow: "none",
    minHeight: "75vh",
    borderRadius: "8px",
    padding: "24px",
    overflowX: "hidden",
    overflowY: "auto",
    mb: 4,
    border: `1px solid ${Colors.borderSecondary}`,
  },

  courseCard: {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
    borderRadius: "8px",
    backgroundColor: Colors.bgSecondary,
    height: "520px",
    width: "340px",
    justifyContent: "center",
    alignContent: "center",
    alignItems: "center",
    cursor: "pointer",
    padding: "12px",
    border: `1px solid ${Colors.borderSecondary}`,
    transition: "all 0.2s ease",
    "&:hover": {
      transform: "translateY(-4px)",
      boxShadow: "0 10px 15px -3px rgba(0,0,0,0.1)",
    },
    [theme.breakpoints.down("sm")]: {
      width: 230,
      height: "375px",
    },
  },

  courseCard2: {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
    borderRadius: "8px",
    backgroundColor: Colors.bgSecondary,
    height: "200px",
    width: "200px",
    justifyContent: "center",
    alignContent: "center",
    alignItems: "center",
    cursor: "pointer",
    padding: "12px",
    border: `1px solid ${Colors.borderSecondary}`,
    transition: "all 0.2s ease",
    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: "0 8px 12px -2px rgba(0,0,0,0.1)",
    },
    [theme.breakpoints.down("sm")]: {
      height: "175px",
      width: "175px",
    },
  },

  cardTitleStyle: {
    fontWeight: 600,
    fontSize: "1.25rem",
    color: Colors.textPrimary,
  },

  tableCard: {
    width: "100%",
    backgroundColor: Colors.tableBg,
    boxShadow: "none",
    marginBottom: 3,
    borderRadius: "8px",
    border: `1px solid ${Colors.borderPrimary}`,
    overflow: "hidden",
  },

  // Enhanced table styling
  dataTable: {
    backgroundColor: Colors.tableBg,
    borderRadius: "8px",
    border: `1px solid ${Colors.borderPrimary}`,
    overflow: "hidden",
    "& .MuiTableHead-root": {
      backgroundColor: Colors.tableHeader,
    },
    "& .MuiTableCell-head": {
      backgroundColor: Colors.tableHeader,
      color: Colors.textPrimary,
      fontWeight: 600,
      fontSize: "0.875rem",
      textTransform: "uppercase",
      letterSpacing: "0.05em",
      borderBottom: `2px solid ${Colors.borderPrimary}`,
    },
    "& .MuiTableCell-root": {
      borderBottom: `1px solid ${Colors.borderSecondary}`,
      padding: "16px",
    },
    "& .MuiTableRow-root:hover": {
      backgroundColor: Colors.tableHover,
    },
  },

  innerCardStyle: {
    margin: "0px auto",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    padding: "16px",
  },

  smallCardStyle: {
    backgroundColor: Colors.bgSecondary,
    boxShadow: "none",
    borderRadius: "6px",
    padding: "16px",
    display: "flex",
    flexDirection: "column",
    border: `1px solid ${Colors.borderSecondary}`,
  },

  statsCard: {
    backgroundColor: Colors.bgSecondary,
    padding: "20px",
    borderRadius: "8px",
    border: `1px solid ${Colors.borderSecondary}`,
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    transition: "all 0.2s ease",
    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: "0 8px 16px rgba(0,0,0,0.1)",
    },
  },

  // Thumbnail and dropzone styles
  thumbsContainer: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    borderRadius: "12px",
    marginTop: "16px",
    maxHeight: 140,
    justifyContent: "center",
    gap: "8px",
  },

  modalThumbsContainer: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    borderRadius: "12px",
    marginTop: "16px",
    maxHeight: 140,
    maxWidth: 200,
    justifyContent: "center",
    gap: "8px",
  },

  thumb: {
    display: "inline-flex",
    borderRadius: "12px",
    border: `1px solid ${Colors.borderPrimary}`,
    marginBottom: "8px",
    width: "100%",
    maxHeight: "85px",
    height: "85px",
    padding: "8px",
    boxSizing: "border-box",
    justifyContent: "center",
    margin: "0 auto",
    backgroundColor: Colors.bgTertiary,
  },

  dropzoneStyle: {
    width: "100%",
    height: "auto",
    borderWidth: 2,
    borderColor: Colors.borderPrimary,
    borderStyle: "dashed",
    borderRadius: "12px",
    transition: "all 0.2s ease",
  },

  thumbInner: {
    display: "flex",
    minWidth: 0,
    overflow: "hidden",
    borderRadius: "8px",
  },

  img: {
    display: "block",
    width: "auto",
    height: "100%",
    borderRadius: "12px",
    objectFit: "cover",
  },

  baseStyle: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "32px",
    borderWidth: 2,
    borderRadius: "12px",
    borderColor: Colors.borderPrimary,
    borderStyle: "dashed",
    backgroundColor: Colors.bgTertiary,
    color: Colors.textSecondary,
    outline: "none",
    transition: "all 0.25s ease",
    cursor: "pointer",
    "&:hover": {
      borderColor: Colors.primary,
      backgroundColor: Colors.bgElevated,
    },
  },

  activeStyle: {
    borderColor: Colors.info,
    backgroundColor: `${Colors.info}10`,
  },

  acceptStyle: {
    borderColor: Colors.success,
    backgroundColor: `${Colors.success}10`,
  },

  rejectStyle: {
    borderColor: Colors.error,
    backgroundColor: `${Colors.error}10`,
  },

  uploadBoxStyle: {
    position: "relative",
    display: "flex",
    justifyContent: "center",
  },

  deleteIcon: {
    display: "flex",
    borderRadius: "8px",
    width: 32,
    height: 32,
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
    position: "absolute",
    right: -8,
    top: -8,
    backgroundColor: Colors.error,
    color: Colors.white,
    transition: "all 0.2s ease",
    "&:hover": {
      backgroundColor: Colors.errorLight,
      transform: "scale(1.1)",
    },
  },

  closeButton: {
    position: "absolute",
    right: 16,
    top: 16,
    color: Colors.textSecondary,
    backgroundColor: Colors.bgTertiary,
    borderRadius: "8px",
    padding: "8px",
    cursor: "pointer",
    transition: "all 0.2s ease",
    "&:hover": {
      backgroundColor: Colors.bgElevated,
      color: Colors.textPrimary,
    },
  },

  uploadBoxStyle2: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "120px",
    maxHeight: "120px",
    maxWidth: "250px",
    position: "relative",
  },

  mockupStyle: {
    display: "flex",
    justifyContent: "center",
    maxHeight: "150px",
    minHeight: "150px",
    margin: "20px",
  },

  // Button styles
  primaryButton: {
    backgroundColor: Colors.primary,
    color: Colors.bgPrimary,
    fontWeight: 600,
    borderRadius: "8px",
    padding: "10px 24px",
    transition: "all 0.2s ease",
    "&:hover": {
      backgroundColor: Colors.primaryDark,
      transform: "translateY(-1px)",
      boxShadow: "0 4px 12px rgba(201, 162, 39, 0.3)",
    },
  },

  secondaryButton: {
    backgroundColor: "transparent",
    color: Colors.textPrimary,
    border: `1.5px solid ${Colors.borderPrimary}`,
    borderRadius: "8px",
    padding: "10px 24px",
    transition: "all 0.2s ease",
    "&:hover": {
      backgroundColor: Colors.bgTertiary,
      borderColor: Colors.primary,
    },
  },

  dangerButton: {
    backgroundColor: Colors.error,
    color: Colors.white,
    fontWeight: 600,
    borderRadius: "8px",
    padding: "10px 24px",
    transition: "all 0.2s ease",
    "&:hover": {
      backgroundColor: Colors.errorLight,
      transform: "translateY(-1px)",
    },
  },

  editButton: {
    backgroundColor: Colors.primary,
    color: Colors.bgPrimary,
    fontWeight: 500,
    borderRadius: "8px",
    padding: "8px 16px",
    transition: "all 0.2s ease",
    "&:hover": {
      backgroundColor: Colors.primaryDark,
    },
  },

  // Input styles
  inputStyle: {
    borderRadius: "8px",
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: Colors.borderPrimary,
      },
      "&:hover fieldset": {
        borderColor: Colors.primary,
      },
    },
  },
};
